import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 9L5 5L1 1", stroke: "currentColor", style: {
  fill: "none"
}, strokeWidth: 1.33, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronRight;
